import script from "./LoopsView.vue?vue&type=script&setup=true&lang=js"
export * from "./LoopsView.vue?vue&type=script&setup=true&lang=js"

import "./LoopsView.vue?vue&type=style&index=0&id=a76772c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a76772c4"]])

export default __exports__